import { render, staticRenderFns } from "./SliderIcon.vue?vue&type=template&id=29493c66&"
import script from "./SliderIcon.vue?vue&type=script&lang=js&"
export * from "./SliderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports